'use client'

import type { Purchase } from 'my-purchases/types/purchaseList'
import { createContext, useCallback, useMemo, useState } from 'react'

interface PurchasesState {
	purchases: Purchase[]
	cursor: string | null
}

export interface PurchasesStateDispatch {
	dispatch: (state?: Partial<PurchasesState>) => void
}

const DEFAULT_INITIAL_STATE: PurchasesState = {
	purchases: [],
	cursor: null,
}

export const PurchasesStateContext = createContext<PurchasesState>(
	DEFAULT_INITIAL_STATE
)
export const PurchasesStateDispatchContext =
	createContext<PurchasesStateDispatch>({
		dispatch: () => {},
	})

export function PurchasesProvider({
	children,
}: {
	readonly children: React.ReactNode
}): React.ReactNode {
	const [state, setState] = useState<PurchasesState>(DEFAULT_INITIAL_STATE)

	const dispatch = useCallback(
		(newState?: Partial<PurchasesState>) =>
			setState((prevState) => ({ ...prevState, ...newState })),
		[]
	)

	const contextValues = useMemo(() => ({ dispatch }), [dispatch])

	return (
		<PurchasesStateContext.Provider value={state}>
			<PurchasesStateDispatchContext.Provider value={contextValues}>
				{children}
			</PurchasesStateDispatchContext.Provider>
		</PurchasesStateContext.Provider>
	)
}
